// Home.js
import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "../sections/HomeSection/HeroSection";
import AboutSection from "../sections/HomeSection/AboutSection";
import ContactSection from "../sections/HomeSection/ContactSection";
import Header from "../components/Header/Header";

function Home() {
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const location = useLocation();

  const handleScrollToAbout = () => {
    aboutRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleScrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (location.state?.scrollTo === "about") {
      setTimeout(() => handleScrollToAbout(), 100);
    } else if (location.state?.scrollTo === "contact") {
      setTimeout(() => handleScrollToContact(), 100);
    } else if (location.state?.scrollTo === "howtouse") {
      setTimeout(() => {
        const element = document.getElementById("demo-video");
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else if (location.state?.scrollTo === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return (
    <>
      <Header
        onAboutClick={handleScrollToAbout}
        onContactClick={handleScrollToContact}
      />
      <HeroSection onContactClick={handleScrollToContact} />

      <div data-section="about" ref={aboutRef}>
        <AboutSection />
      </div>

      <div data-section="contact" ref={contactRef}>
        <ContactSection />
      </div>
    </>
  );
}

export default Home;